<template>
<div class="exam-detail">
  <div class="header">
    <h2 class="title">{{examData.title}}</h2>
    <ul class="subject" v-if="examData.subjectList">
      <li>
        【<span v-if="examData.subjectList[currentIndex].optionType==1">单选</span><span v-if="examData.subjectList[currentIndex].optionType==2">多选</span>】（{{examData.subjectList[currentIndex].score}}分）
        <span class="progress"><span class="current">{{currentIndex+1}}</span>/{{listLength}}</span>
      </li>
      <li>{{examData.subjectList[currentIndex].subjectDesc}}</li>
    </ul>
  </div>
  <div class="option-box" v-if="examData.subjectList">
    <exam-option :mode="{ 'radio' : examData.subjectList[currentIndex].optionType==1,'checkbox' : examData.subjectList[currentIndex].optionType==2, }"
                 :options="examData.subjectList[currentIndex].optionList"
                 @check="checkItem"></exam-option>
  </div>
  <div class="button-box ucar-row">
    <div class="ucar-col" v-if="currentIndex != 0">
      <span class="button" @click="prev">上一题</span>
    </div>
    <div class="ucar-col" v-if="currentIndex != listLength-1">
      <span class="button color" @click="next">下一题</span>
    </div>
    <div class="ucar-col" v-if="currentIndex == listLength-1">
      <span class="button color" @click="submit">提交结果</span>
    </div>
  </div>
</div>
</template>

<script>
import ExamOption from '../../components/exam-option'
import { examCommit } from '../../api'

export default {
    data () {
    return {
      title: '课后测试',
      examData: {},
      currentIndex: 0,
      listLength: 0,
    }
  },
  components: { ExamOption },
  methods: {
    // 选中选项时候触发
    checkItem (index) {
      // 根据后台接口要求，选中为1 未选中为0
      if (this.examData.subjectList[this.currentIndex].optionType === 1) { // 单选
        this.examData.subjectList[this.currentIndex].optionList.map(i => {
          i.checkFlag = 0
        })
        this.examData.subjectList[this.currentIndex].optionList[index].checkFlag = 1
      } else { // 多选
        this.examData.subjectList[this.currentIndex].optionList[index].checkFlag = Number(this.examData.subjectList[this.currentIndex].optionList[index].checkFlag) === 1 ? 0 : 1
      }
    },
    // 校验当前页面的题目是否选中答案
    isFillIn () {
      return this.examData.subjectList[this.currentIndex].optionList.some(i => {
        return i.checkFlag > 0
      })
    },
    // 上一题，不需要通知server
    prev () {
      this.currentIndex--
    },
    next () {
      // 没有选中不允许下一题
      if (!this.isFillIn()) {
        this.$alert('请作答')
        return
      }
      this.currentIndex++
    },
    // 交卷，接口完成后，跳转到结束页面
    submit () {
      const sendPaper = _ => {
        this.commitExam(this.answerData(2), examInfo => {
          this.setVuexTrainExamResult({
            errorExam: this.checkExam(),
            courseId: this.examData.courseId,
            examInfo
          })
          this.$router.replace('/exam-result')
        })
      }
      // 没有选中禁止交卷
      if (!this.isFillIn()) {
        this.$alert({
          type: 'confirm',
          dsc: '还有未完成题目，请作答后交卷？',
          center: true,
        })
        return
      }
      // 点击交卷按钮，校验试卷已经全部作答时，提示
      this.$alert({
          type: 'confirm',
          dsc: '是否确认交卷',
          showCancel: true,
          center: true,
          callback: () => {
            sendPaper()
          }
      })
    },
    /**
     * 交卷/同步试卷 ajax
     * @param data 试卷信息和答案
     * @param callback
     */
    commitExam (req, callback) {
      examCommit(req)
        .then(data => {
          if (Number(data.busiStatus) === 0) {
            const res = {
              score: data.score,
              passFlag: data.passFlag,
              title: this.examData.title
            }
            callback && callback(res)
          } else {
            this.$alert({
              type: 'confirm',
              dsc: data.busiMsg,
              center: true,
              callback: () => {
                this.$router.back()
              }
            })
          }
        })
    },
    /**
     * 获取错题集
     * @returns {any}
     */
    checkExam () {
      let errorExam = []
      this.examData.subjectList.forEach(item => {
        for (let i = 0; i < item.optionList.length; i++) {
          if (item.optionList[i].checkFlag !== item.optionList[i].correctAnswer) {
            errorExam.push(item)
            break
          }
        }
      })
      return errorExam
    },
    /**
     * 遍历试卷，整理返回作答的答案
     * @returns {{examId: *, examType: number, subjectList: Array }}
     */
    answerData () {
      // 以下是交卷的逻辑
      let answer = {
        examType: 1, // （1：课后测试，2：考试）
        isMakeup: 0, // 是否补考（0：不是 1：是）
        examId: this.examData.quizId, // 课后测试传quizId
        relevanceId: this.vuexRecruitId,
        subjectList: []
      }
      this.examData.subjectList.forEach(item => {
        answer.subjectList.push({
          serialNo: item.serialNo,
          answer: this.getAnswer(item),
          correctAnswer: this.getCorrectAnswer(item),
          score: item.score
        })
      })
      return answer
    },
    /**
     * 根据题目，返回已经勾选的答案
     * @param subject 题目Object
     * @returns {string} 答案，格式为 1,2,3,4
     */
    getAnswer (subject) {
      let answer = []
      subject.optionList.forEach(item => {
        Number(item.checkFlag) === 1 && answer.push(item.serialNo)
      })
      return answer.join(',')
    },
    /**
     * 根据题目，返回该题的正确答案
     * @param subject 题目Object
     * @returns {string} 答案，格式为 1,2,3,4
     */
    getCorrectAnswer (subject) {
      let correctAnswer = []
      subject.optionList.forEach(item => {
        Number(item.correctAnswer) === 1 && correctAnswer.push(item.serialNo)
      })
      return correctAnswer.join(',')
    }
  },
  mounted () {
    if (!this.vuexTrainExamData) {
      this.$router.back()
      return
    }
    this.examData = this.vuexTrainExamData
    this.listLength = this.examData.subjectList.length
  }
}
</script>

<style lang="stylus" scoped>
@import "../../styles/variable.styl";
.exam-detail {
  .header {
    margin-bottom: 60px;
    padding: 40px 30px 150px;
    background-color: $ucar_main_color;
    color: #fff;
    .title {
      ucar-text-overflow();
      text-align: center;
    }
    .time {
      text-align: center;
      margin-bottom: 0;
    }
    .subject {
      color: $ucar_font_color;
      background-color: #fff;
      padding: 30px;
      ucar-border-radius();
      position: relative;
      bottom: -40px;
      li {
        display: block;
        line-height: 50px;
        & + li {
          margin-top: 20px;
          padding-top: 20px;
          border-top: 1px solid $ucar_light_border;
        }
        .progress {
          float: right;
          .current {
            color: $ucar_label_color;
          }
        }
      }
    }
  }
  .option-box {
    padding: 0 30px;
    flex: 1 0 auto;
  }
  .button-box {
    box-sizing: border-box;
    background-color: $ucar_main_bg;
    padding: 30px 15px;
    .ucar-col {
      padding: 0 15px;
      .button {
        font-size: $ucar_font_h5;
        display: block;
        width: 100%;
        height: 90px;
        line-height: 90px;
        text-align: center;
        border: 1px solid $ucar_light_border;
        color: $ucar_font_assist_color;
        background-color: #fff;
        ucar-border-radius();
        &.color {
          color: #fff;
          background-color: $ucar_main_color;
          border-color: $ucar_main_color;
        }
      }
    }
    .ucar-col + .ucar-col {
      margin-top: 15px;
    }
  }
}
</style>
